export default __webpack_public_path__ + "static/media/Avatar-1-noback.76269792.png";